<template>

  <div v-if="editMode || filled">
    <div class="card-header">
      <i
        v-if="!editable && editMode"
        class="fas fa-pencil-alt"
        :title="$t('Edit')"
        @click.stop="editSection(true)"
        style="cursor: pointer; float: right;">
        </i>
      <strong>Habilidades</strong>
    </div>
    <div class="card-body" v-if="editable">
      <form v-on:submit.prevent="save(candidateEdit)">
        
        <div class="row">
          <div class="col">
            <label><strong>Domínio</strong></label>
            <div class="input-group mb-3">
              <input type="text" class="form-control" @keydown.enter.prevent="addItem($event, 4)">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" type="button">+</button>
              </div>
            </div>
            <ul class="list-group">
              <li 
                v-for="(item, index) in candidateEdit.skills" v-if="item.level==4"
                :key="index"
                class="list-group-item">
                {{ item.skill }}
                <a href="javascript:void(0)" @click="candidateEdit.skills.splice(index, 1);">x</a>
              </li>
            </ul>
          </div>
          <div class="col">
            <label><strong>{{ $t('Advanced') }}</strong></label>
            <input type="text" class="form-control" @keydown.enter.prevent="addItem($event, 3)">
            <ul class="list-group">
              <li 
                v-for="(item, index) in candidateEdit.skills" v-if="item.level==3"
                :key="index"
                class="list-group-item">
                {{ item.skill }}
                <a href="javascript:void(0)" @click="candidateEdit.skills.splice(index, 1);">x</a>
              </li>
            </ul>
          </div>
          <div class="col">
            <label><strong>{{ $t('Average') }}</strong></label>
            <input type="text" class="form-control" @keydown.enter.prevent="addItem($event, 2)">
            <ul class="list-group">
              <li 
                v-for="(item, index) in candidateEdit.skills" v-if="item.level==2"
                :key="index"
                class="list-group-item">
                {{ item.skill }}
                <a href="javascript:void(0)" @click="candidateEdit.skills.splice(index, 1)">x</a>
              </li>
            </ul>
          </div>
          <div class="col">
            <label><strong>{{ $t('Basic') }}</strong></label>
            <input type="text" class="form-control" @keydown.enter.prevent="addItem($event, 1)">
            <ul class="list-group">
              <li 
                v-for="(item, index) in candidateEdit.skills" v-if="item.level === 1"
                :key="index"
                class="list-group-item">
                {{ item.skill }}
                <a href="javascript:void(0)" @click="candidateEdit.skills.splice(index, 1)">x</a>
              </li>
            </ul>
          </div>
        </div>

        <ValidateMessage :error="validateErrors.skills" />

        <div
          class="mt-3"
          :class="{'box-loading': loading}">
          <button
            type="submit"
            class="btn btn-primary">
            {{ $t('Save') }}
            </button>
          <button
            type="button"
            class="btn btn-light"
            @click.stop="editSection(false)">
            {{ $t('Cancel') }}
            </button>
        </div>

      </form>
    </div>
    <div
      v-if="!editable && filled"
      class="card-body">
      <div class="row">
        <div class="col">
          <label><strong>{{ $t('Advanced') }}</strong></label>
          <ul class="skill-list">
            <li 
              v-for="(item, index) in candidate.skills" v-if="item.level === 4"
              :key="index">{{ item.skill }}</li>
          </ul>
        </div>
        <div class="col">
          <label><strong>Domínio</strong></label>
          <ul class="skill-list">
            <li 
              v-for="(item, index) in candidate.skills" v-if="item.level === 3"
              :key="index">{{ item.skill }}</li>
          </ul>
        </div>
        <div class="col">
          <label><strong>{{ $t('Average') }}</strong></label>
          <ul class="skill-list">
            <li 
              v-for="(item, index) in candidate.skills" v-if="item.level === 2"
              :key="index">{{ item.skill }}</li>
          </ul>
        </div>
        <div class="col">
          <label><strong>{{ $t('Basic') }}</strong></label>
          <ul class="skill-list">
            <li 
              v-for="(item, index) in candidate.skills" v-if="item.level === 1"
              :key="index">{{ item.skill }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'CandidateProfileSkills',
  components: {
  },
  props: [
    'editMode'
  ],
  data () {
    return {
      loading: false,
      sectionEdit: false,
      candidateEdit: {},
      validateErrors: false
    }
  },
  created () {
  },
  computed: {
    editable () {
      return this.sectionEdit && this.editMode
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    filled () {
      return this.candidate.skills && this.candidate.skills.length
    }
  },
  methods: {
    /*
    addItem
    */
    addItem (event, level) {
      let value = event.target.value
      if (value) {
        this.candidateEdit.skills = this.candidateEdit.skills.filter((v) => {
          return !(v.skill === value)
        })
        this.candidateEdit.skills.push({
          skill: value,
          level: level
        })
        event.target.value = ''
      }
    },
    /*
    editSection
    */
    editSection (status) {
      this.sectionEdit = status
      this.candidateEdit = {
        _id: this.candidate._id,
        skills: Array.isArray(this.candidate.skills) ? this.candidate.skills : []
      }
    },
    /*
    save
    */
    save (data) {
      this.loading = true

      this.$store.dispatch('updateCandidate', data)
      .then((response) => {
        this.loading = false
        this.sectionEdit = false
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Profile/CandidateProfileSkills.vue